import React, { Component, Fragment } from 'react';
import { components } from '@kurtosys/ksys-app-components';
import { inject, observer } from 'mobx-react';

import QuestionWizard from '../QuestionWizard/QuestionWizard.js';
import Results from '../Results/Results.js';
import DebugInfoAction from '../shared/DebugInfoAction.js';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.js';
import Loading from '../shared/Loading.js';
import SkeletonLoader from '../shared/SkeletonLoader.js';

import { IAppProps } from './models/IAppProps.js';
import { IAppState } from './models/IAppState.js';
import Commentary from './styledComponents/Commentary.js';
import Wrapper from './styledComponents/Wrapper.js';

const Disclaimer = components.overview.Disclaimer.Disclaimer;
const NoDataPlaceholder = components.base.NoDataPlaceholder.NoDataPlaceholder;
const Card = components.base.Card.Card;
const Application = components.base.Application.Application;

class RawApp extends Component<IAppProps, IAppState> {
	static configurationKey = 'app' as const;
	static styleKey = 'app' as const;
	render() {
		const { className, appStore, selector, queryStore, quizStore } = this.props;

		if (!appStore || !queryStore || !quizStore) {
			return null;
		}
		const { isBootstrapped, dataContextStatus, skeletonLoader, skeletonLoaders } = appStore;
		if (!isBootstrapped || dataContextStatus === 'PENDING') {
			const { embedLoadingElement } = this.props;

			if (skeletonLoader && !embedLoadingElement) {
				return (
					<SkeletonLoader config={skeletonLoader} variables={skeletonLoaders && skeletonLoaders.variables} />
				);
			}
			return <Loading embedLoadingElement={embedLoadingElement} />;
		}
		const {
			theme,
			show,
			commentary,
			showPlaceholder,
			noDataPlaceholder: noDataPlaceholderText,
			noDataPlaceholderDisclaimer,
			libraryComponentsConfiguration,
			appCardProps,
			getTranslateFunction,
			culture,
			assets,
			assetCacheOptions,
			assetRegisters,
			getAccessibilityTextFunction,
			hideCommentary,
		} = appStore;

		if (!show) {
			return null;
		}

		const noDataPlaceholder =
			(noDataPlaceholderDisclaimer && <Disclaimer {...noDataPlaceholderDisclaimer} />) ||
			(noDataPlaceholderText && <NoDataPlaceholder>{noDataPlaceholderText}</NoDataPlaceholder>);

		const translate = getTranslateFunction();
		const accessibilityText = getAccessibilityTextFunction();
		const { isComplete } = quizStore;

		return (
			<Application
				theme={theme}
				configuration={libraryComponentsConfiguration}
				translate={translate}
				culture={culture}
				assets={assets}
				assetCacheOptions={assetCacheOptions}
				assetRegisters={assetRegisters}
				accessibilityText={accessibilityText}
				analyticsHelper={appStore.analyticsHelper}
			>
				<DebugInfoAction appStore={appStore} />
				<Wrapper className={className}>
					<Card {...appCardProps}>
						{showPlaceholder && noDataPlaceholder}
						{!showPlaceholder && (
							<Fragment>
								{!isComplete && <QuestionWizard />}
								{isComplete && <Results />}
							</Fragment>
						)}
					</Card>
					{!hideCommentary && <Commentary value={commentary} hasHtmlContent={true} />}
				</Wrapper>
			</Application>
		);
	}
}

export const App = inject('appStore', 'queryStore', 'quizStore')(observer(RawApp));
export default InjectedStyledComponent(App, 'app');
